import { FAQPageJsonLd, NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import { useEffect, useMemo, useRef, useState } from 'react';
import NewFooter from '../../../../src/components/HomePage/NewFooter';
import { getSeoVisibility } from '../../../appconfig';
import GlobalStyle from '../../../styles/globalStylesV2';
import { SnackBar } from '../../Product/PdpHeader/styled';
import { GridWrapper } from '../../StoreHomePage/BannersGrid/styled';
import GeneralItemListing from '../../StoreHomePage/GeneralItemListing/GeneralItemListing';
import { DiaperHeading, HiddenWrapper } from '../B2G1RadioOption/styled';
import SelectDiaperButton from '../SelectDiaperButton';
import {
  addTocartBogoHandler,
  goToCartHandler,
} from '../../../Utils/productAction';
import { fireEventForRepeatUser } from '../../../Utils/useFirebase';
import Head from 'next/head';
import LazyLoad from 'react-lazyload';
import { clothDiaperFAQ } from '../../../Utils/SEO/constants';
import {
  getScreenName,
  getUserIsLoggedIn,
  showNewCartFlow,
} from '../../../Utils/helper';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import { DiaperWrapper } from '../../IVF/IVFCarousel/styled';
import TopCarousel from '../../StoreHomePage/TopCarousel';
import { AccordionHeading } from '../../StoreHomePage/UniversalAccordion/styled';
import WhatsappStrip from '../../StoreHomePage/WhatsappStrip';
import GotoTopButton from '../GotoTopButton';
import ReadyToChoiceSection from '../ReadyToChoiceSection';
import SelectYourDiaperCTA from '../SelectYourDiaperCTA';
import FloatingVideo from '../../FloatingVideo/index';
import { useRouter } from 'next/router';
import { b2G1_recover_key } from '../../../Constants/AddressPage';
import {
  base_date,
  convertToLocaleFormat,
  format_locale_date_ind,
  getClosestUpdateTimeInMin,
  getDifferenceDate,
  getIndexChangeArr,
  getTotalOrders,
  isInViewport,
  liveCountText,
  priceTableConstant,
} from '../../../Constants/B2G1CategoryPage';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import HappinessPattern from '../../ProductNew/HappinessPattern/HappinessPattern';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import { getProductIds } from '../../StoreHomePage/BogoClothDiaper/common';
import UniversalAccordion from '../../StoreHomePage/UniversalAccordion';
import B2G1Head from '../B2G1Head';
import DiaperRadioOptionNew from '../B2G1RadioOptionNewVersion';
import CDPageLiveCount from '../CDPageLiveCount';
import ClothDiaperCertificates from '../ClothDiaperCertificates';
import { constantTexts } from '../DiaperPageRadioOptions/constant';
import {
  categoryAccordionData,
  certificatesData,
  FAQDataClothDiaper,
  readyToChoiceGif,
} from '../TopBannerwithtext/constant';
import {
  cdlistingnewversion,
  changeToArraywithShuffling,
  hardcodedIds,
  newcdlistingnewversion,
  showOtherHardcodedSkus,
} from './constant';
import Cookies from 'js-cookie';
import {
  checkEligibilityForSsoTooltip,
  getNewAndRepeatUser,
  showDiaperSwitch,
} from '../../../Utils/commonUtils';
import B2G1ProgressRadioButton from '../B2G1ProgressRadioButton';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { fireEvent } from '../../../Utils/fireEvent';
import CategoryHeadElement from '../CategoryHeadElement';
const KwikPassSsoTooltip = dynamic(() => import('../../KwikPassSsoTooltip'), {
  ssr: false,
});
import { logUserEventData } from '../../../datafetchers/productPage';
import { getUserId } from '../../../datafetchers/PaymentDropOff';

const RatingandReviews = dynamic(
  () => import('../../Product/RatingandReviews'),
  {
    ssr: false,
  },
);
const NewHeader = dynamic(() => import('../../HomePage/NewHeader'), {
  ssr: false,
});

export default function DiaperNewVersionMain(props) {
  const {
    generalItemsData,
    categoryData,
    secondLineHeading,
    firstLineHeading,
    reviewdata,
    offerKey,
    diaperOfferData,
    isIndex,
    productIds,
    show3d,
    experimentUserType,
    isForNewCdPage,
    showNewCDDDPage,
    productData,
  } = props;
  const diapernewversionProduct = { items: [] };
  if (isForNewCdPage) {
    diapernewversionProduct.items = [
      ...generalItemsData?.items,
      ...newcdlistingnewversion?.items,
    ];
  } else {
    diapernewversionProduct.items = [
      ...generalItemsData?.items,
      ...cdlistingnewversion?.items,
    ];
  }

  const floatingVideoData = generalItemsData?.items.find(
    (item) => item.itemType == 'TYPE_REELS',
  );

  if (floatingVideoData) {
    diapernewversionProduct.items = diapernewversionProduct.items.filter(
      (obj) => obj.itemType != 'TYPE_REELS',
    );

    diapernewversionProduct.items = diapernewversionProduct.items.map((item) =>
      item._id == 3123 ? floatingVideoData : item,
    );
  }

  const [generalItemsState, setGeneralItemsState] = useState(
    JSON.parse(JSON.stringify(generalItemsData)),
  );
  const router = useRouter();
  const [option, setOption] = useState();
  const [offerCartData, setOfferCartData] = useState(diaperOfferData?.data);
  let images = [];
  diapernewversionProduct?.items?.forEach((element) => {
    if (
      element?.itemType === 'MULTIPLE_ITEMS' &&
      element?.viewType === 'GRID' &&
      element?.[0]?.itemType == 'PRODUCT'
    ) {
      element?.items?.map((data) => {
        images.push(data.image);
      });
    }
  });
  const [showCartSnackBar, setShowCartSnackBar] = useState(false);
  const [hideStickyStrip, setHideStickyStrip] = useState(false);
  const [showHeader, setShowHeader] = useState('-56px');
  const [showTop, setShowTop] = useState(false);
  const [categoryNavBarTop, setCategoryNavBarTop] = useState(56);
  const oldScrollValue = useRef(0);
  const refScrollUp = useRef();
  const goTopRef = useRef();
  const lockedProductSectionRef = useRef(null);
  const particularElementRef = useRef(null);
  const throttleTimeout = useRef(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [showLockedProductsAnimation, setShowLockedProductsAnimation] =
    useState(false);
  const [showGoTop, setshowGoTop] = useState('goTopHidden');
  const [changeCartCount, setChangeCartCount] = useState();
  const [closeCart, setCloseCart] = useState(false);
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [isFullScreenVideoEnabled, setIsFullScreenVideoEnabled] =
    useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const storeHomeItems = generalItemsState?.items;
  const metaTitle = generalItemsState?.metaTitle || generalItemsState?.tabName;
  const metaDescription = generalItemsState?.metaDescription;
  const Footnotes = storeHomeItems?.filter(function (item) {
    return item?.itemType === 'SEO_FOOTNOTE';
  });
  const heading = Footnotes?.[0]?.heading;
  const htmlText = Footnotes?.[0]?.htmlText;
  let priceTable = Footnotes?.[0]?.priceTable;
  const ratingTable = Footnotes?.[0]?.reviewTable;
  const updatedOn = Footnotes?.[0]?.lastUpdatedAtDate;
  let endIndex = priceTable?.indexOf('</table>');
  priceTable =
    priceTable?.substring(0, endIndex) +
    priceTableConstant +
    priceTable?.substring(endIndex);
  const headerHidden = useRef(true);
  const isDesktop = useIsDesktop();
  const [pageLiveCountValue, setPageLiveCountValue] = useState(0);
  const [changedIndexes, setChangedIndexes] = useState([]);
  const [userType, setUserType] = useState();
  const timerRef = useRef('');
  const selectDiaperRef = useRef(null);
  const [elementInViewport, setElementInViewport] = useState(false);
  const [showHeading, setShowHeading] = useState(true);
  const [showB2G1Snackbar, setShowB2G1Snackbar] = useState(null);
  const [productCount, setProductCount] = useState(0);
  const [nonFreebieProductCount, setNonFreebieProductCount] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [showFullScreenVideo, setShowFullScreenVideo] = useState(false);
  const [showSsoTooltipDot, setShowSsoTooltipDot] = useState(false);
  const [showSsoTooltip, setShowSsoTooltip] = useState(false);
  const [loginPopUp, setLoginPopUp] = useState(false);
  const headingText = hideStickyStrip
    ? constantTexts.one_diaper
    : option === '3'
      ? constantTexts.five_diaper
      : option == '4'
        ? constantTexts.two_cd_1diaper
        : constantTexts.three_diaper;

  if (showHeader == '0px' || isDesktop) headerHidden.current = false;
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'ecommerce',
    url: 'https://mylofamily.com/store/clothdaipers',
  };
  const FAQPage = [];
  clothDiaperFAQ?.map((element) => {
    if (element?.question && element?.answer) {
      FAQPage.push({
        questionName: element?.question,
        acceptedAnswerText: element?.answer,
      });
    }
  });
  const faqEventData = {
    category: 'impression_section_in_myloshop',
    section_id: '',
    section_name: 'FAQ section',
    shape: '',
    card_ids: '',
    deeplink_value: null,
  };
  const recoverDataFlow = async () => {
    const sku_ids = router.query[b2G1_recover_key];
    // console.log("router.query", router.query);
    if (sku_ids) {
      const params = {
        productId: sku_ids,
        ids: getProductIds(offerCartData?.productList),
        add: false,
        less: false,
        addToCart: true,
        isFirstTime: false,
        selectedProductId: sku_ids.split(',')[0],
      };
      const data = await addTocartBogoHandler(params, true);
      setOfferCartData(data?.data);
    }
  };
  useEffect(() => {
    if (!getUserIsLoggedIn()) recoverDataFlow();
  }, [router.query.sku_ids]);
  useEffect(() => {
    setCloseCart(false);
    if (closeCart) {
      clientSideApiCall();
    }
  }, [closeCart]);

  useEffect(() => {
    if (isDesktopUser()) {
      setShowHeader('0px');
    }
    setUserType(getWebUserType());
    oldScrollValue.current = window.pageYOffset;

    function scrollUpOrDown() {
      if (!throttleTimeout.current && !isDesktopUser()) {
        setTimeout(() => {
          let newValue = window.pageYOffset;
          if (oldScrollValue.current < newValue) {
            setCategoryNavBarTop(-19); //for Desktop screen
            if (newValue > 56) {
              setShowHeader('-56px'); // for Mweb
              setShowTop(true);
            }

            //on scroll down
          } else if (oldScrollValue.current > newValue) {
            setCategoryNavBarTop(56); // for Desktop screen
            setShowHeader('0px'); // for Mweb
            setShowTop(true);
            // on scroll up
          }
          oldScrollValue.current = newValue;
          throttleTimeout.current = false;
        }, 100);
      }
      throttleTimeout.current = true;
      const isInViewPort = isInViewport(selectDiaperRef.current);
      if (isInViewPort === true) setElementInViewport(isInViewPort);
    }

    window.addEventListener('scroll', scrollUpOrDown);

    const current_date = new Date();
    const { days, minutes } = getDifferenceDate(current_date, base_date);
    const total_orders = getTotalOrders(days, minutes);

    setPageLiveCountValue(total_orders);
    setShowTop(false);
    Cookies.set('visitedCD', true);
    return () => {
      window.removeEventListener('scroll', scrollUpOrDown);
    };
  }, []);

  useEffect(() => {
    if (elementInViewport) updateLiveCount();
  }, [elementInViewport]);

  useEffect(() => {
    if (pageLiveCountValue) {
      clearTimeout(timerRef.current);
      const timer = getClosestUpdateTimeInMin() * 60 * 1000;
      timerRef.current = setTimeout(updateLiveCount, [timer]);
    }
  }, [pageLiveCountValue]);

  const updateLiveCount = () => {
    setPageLiveCountValue((prev) => prev + 1);
    let num1 = convertToLocaleFormat(
      pageLiveCountValue,
      format_locale_date_ind,
    ).split('');
    let num2 = convertToLocaleFormat(
      pageLiveCountValue + 1,
      format_locale_date_ind,
    ).split('');

    let index_change = getIndexChangeArr(num1, num2);
    setChangedIndexes(index_change);
    setTimeout(() => {
      setChangedIndexes([]);
    }, [2000]);
  };

  useEffect(() => {
    setChangeCartCount(false);
    if (changeCartCount && !showNewCartFlow()) {
      setShowCartSnackBar(true);
      setTimeout(() => {
        setShowCartSnackBar(false);
      }, 3000);
    }
  }, [changeCartCount]);

  const handleVisibleButton = () => {
    const scrollPosition = goTopRef?.current?.getBoundingClientRect()?.top;
    if (scrollPosition < 200) {
      return setshowGoTop('goTopShow');
    } else if (scrollPosition > 200) {
      return setshowGoTop('goTopHidden');
    }
  };

  const handleScrollUp = () => {
    refScrollUp.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sku_ids = params.get('sku_ids');
    clientSideApiCall(sku_ids);
    localStorage.setItem('sideDrawerData', JSON.stringify(categoryData));
    fireEvent({
      category: 'viewed_landing_page',
      screen_name: getScreenName(),
      support_letiable: `{offer_name : ${offerKey}}`,
      parent: getNewAndRepeatUser(),
    });
    if (getUserIsLoggedIn()) {
      logUserEventData('viewed_landing_page', [
        {
          userId: getUserId(),
          productId: 504,
          language: '1',
        },
      ]);
    }
    fireEventForRepeatUser('category_page');
    window.addEventListener('scroll', handleVisibleButton);

    return () => {
      window.removeEventListener('scroll', handleVisibleButton);
    };
  }, []);
  const memoisedBanners = useMemo(() => {
    const items = storeHomeItems;
    const BannerComponents = [];
    items?.forEach((element) => {
      switch (element?.viewType) {
        case 'CAROUSEL':
          if (element?.items?.[0]?.itemSize == 'LARGE') {
            BannerComponents.push(
              <TopCarousel
                banner={element}
                type={element?.viewType}
                key={element?.itemName}
                clothDiaperPage={true}
                isForNewCdPage={isForNewCdPage}
              />,
            );
          }
      }
    });
    return BannerComponents;
  }, [storeHomeItems, showHeader]);

  const cartCtaHandler = () => {
    fireEvent({
      category: 'clicked_go_to_cart_in_snackbar',
      screen_name: getScreenName(),
      item_count: cartItems.length || 0,
      id: cartItems.pop(),
    });
    goToCartHandler();
  };

  const clientSideApiCall = async (crm_flow) => {
    const value = localStorage.getItem('option') || '1';
    setOption(value);
    let commaSeperatedIds = null;
    if (showOtherHardcodedSkus()) {
      const newCardIds = productIds + ',' + hardcodedIds;
      const getShuffledIds = changeToArraywithShuffling(newCardIds);
      commaSeperatedIds = getShuffledIds?.toString();
    } else {
      commaSeperatedIds = productIds;
    }

    if (value === '2') {
      setHideStickyStrip(true);
      setOfferCartData({});
    } else if (!crm_flow) {
      const params = {
        productId: '970',
        ids: commaSeperatedIds,
        add: false,
        less: false,
        addToCart: false,
        isFirstTime: false,
        selectedProductId: '970',
        selectProduct: true,
      };
      const data = await addTocartBogoHandler(params);
      setOfferCartData(data?.data);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVideoVisible(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  const showB2g1Snackbar = (text) => {
    setShowB2G1Snackbar(text);
    setTimeout(() => {
      setShowB2G1Snackbar(null);
    }, 2500);
  };

  useEffect(() => {
    if (!getUserIsLoggedIn() && showHeader == '0px') {
      const showKwikPassSsoTooltip = checkEligibilityForSsoTooltip();
      setShowSsoTooltip(showKwikPassSsoTooltip);
    } else {
      setShowSsoTooltip(false);
    }
  }, [getUserIsLoggedIn(), showHeader]);

  useEffect(() => {
    if (
      getUserIsLoggedIn() ||
      !checkEligibilityForSsoTooltip() ||
      showHeader != '0px'
    ) {
      setShowSsoTooltip(false);
      return;
    }
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        if (showSsoTooltip) {
          setShowSsoTooltipDot(true);
        }
        setShowSsoTooltip(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setShowSsoTooltip(true);
        setShowSsoTooltipDot(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSsoTooltip]);

  const openLoginPopUp = () => {
    setLoginPopUp(true);
  };

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
          />
          {FAQPage?.length > 0 && <FAQPageJsonLd mainEntity={FAQPage} />}
          {isIndex && (
            <B2G1Head reviewdata={reviewdata} data={diapernewversionProduct} />
          )}
          {
            // Daiper Experimental Page
          }
          {firstLineHeading && !isIndex && (
            <Head>
              <meta name="robots" content="noindex, nofollow" />
              <meta name="googlebot" content="noindex, nofollow" />
              <link
                key="canonical"
                rel="canonical"
                href={
                  'https://mylofamily.com/category/reusable-cloth-diapers-5433'
                }
              />
            </Head>
          )}
        </>
      ) : null}
      <CategoryHeadElement
        categoryId={'504'}
        categoryData={{
          tabName: 'Day and Night Diapers',
          icon: 'https://images.myloapp.in/NestJsUploads/1731925072465-image-removebg-preview-(24).webp',
          webUrl: '/category/Day-And-Night-Diapers',
        }}
      />
      <GlobalStyle />
      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryData}
        addedToCart={changeCartCount}
        showCart={true}
        showTrackOrder={true}
        setAddedToCart={setChangeCartCount}
        setCloseCart={setCloseCart}
        showHeader={showHeader}
        categoryNavBarTop={categoryNavBarTop}
        location={'cdPage'}
        pageLocation={'B2G1'}
        hideCompleteHeader={headerHidden.current}
        nostrip={true}
        productId={5433}
        setIsCartOpen={setIsCartOpen}
        isForNewCdPage={isForNewCdPage}
        showSsoTooltipDot={showSsoTooltipDot}
        loginPopUp={loginPopUp}
        setLoginPopUp={setLoginPopUp}
      />
      <KwikPassSsoTooltip
        setShowSsoTooltip={setShowSsoTooltip}
        fromCategory={true}
        showSsoTooltip={showSsoTooltip}
        openLoginPopUp={openLoginPopUp}
      />
      {/* <OTIStrip pageType={"fab_friday_page"} /> */}
      <DiaperWrapper
        userType={showDiaperSwitch(userType)}
        catHideHeader={showHeader == '-56px'}
        isForNewCdPage={isForNewCdPage && showHeader != '-56px'}
      >
        <div ref={refScrollUp}></div>
        {memoisedBanners}
        {isForNewCdPage && (
          <>
            <B2G1ProgressRadioButton
              offerCartData={offerCartData}
              lockedProductSectionRef={lockedProductSectionRef}
              setShowAnimation={setShowAnimation}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              showNewCDDDPage={showNewCDDDPage}
              isDesktop={isDesktop}
            />
          </>
        )}
        {!isForNewCdPage && (
          <>
            <DiaperHeading>Reusable Cloth Diapers</DiaperHeading>
            {/* <ViewInRoomBanner /> */}
            <ClothDiaperCertificates certificatesData={certificatesData} />
          </>
        )}
        <HiddenWrapper>
          {!isForNewCdPage && (
            <DiaperRadioOptionNew
              setOfferCartData={setOfferCartData}
              setHideStickyStrip={setHideStickyStrip}
              clientSideApiCall={clientSideApiCall}
              setChangeCartCount={setChangeCartCount}
              setOption={setOption}
              option={option}
              newDiaperVersion={true}
              experimentUserType={experimentUserType}
              setShowHeading={setShowHeading}
              setShowAnimation={setShowAnimation}
            />
          )}
          <div ref={particularElementRef}></div>
          {!hideStickyStrip ? (
            <SelectDiaperButton
              offerCartData={offerCartData}
              setShowAnimation={setShowAnimation}
              setOfferCartData={setOfferCartData}
              option={option}
              experimentUserType={experimentUserType}
              isForNewCdPage={isForNewCdPage}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              lockedProductSectionRef={lockedProductSectionRef}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              nonFreebieProductCount={nonFreebieProductCount}
            />
          ) : null}

          <div>
            <SnackBar className={showCartSnackBar ? 'show' : ''}>
              ADDED TO CART SUCCESSFULLY{' '}
              <span onClick={cartCtaHandler}>GO TO CART</span>
            </SnackBar>
            <GeneralItemListing
              setChangeCartCount={setChangeCartCount}
              data={diapernewversionProduct}
              setOfferCartData={setOfferCartData}
              offerCartData={offerCartData}
              hideStickyStrip={hideStickyStrip}
              clothDiaper={true}
              showAnimation={showAnimation}
              newDiaperVersion={true}
              showGoTop={showGoTop}
              scrollUp={handleScrollUp}
              userType={userType}
              particularElementRef={particularElementRef}
              setShowAnimation={setShowAnimation}
              headingText={showHeading ? headingText : 'loading'}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              isFullScreenVideoEnabled={isFullScreenVideoEnabled}
              isForNewCdPage={isForNewCdPage}
              lockedProductSectionRef={lockedProductSectionRef}
              showLockedProductsAnimation={showLockedProductsAnimation}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              showB2g1Snackbar={showB2g1Snackbar}
              productCount={productCount}
              setProductCount={setProductCount}
              setNonFreebieProductCount={setNonFreebieProductCount}
              nonFreebieProductCount={nonFreebieProductCount}
              setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
              setShowFullScreenVideo={setShowFullScreenVideo}
              setCurrentVideoIndex={setCurrentVideoIndex}
              showNewCDDDPage={showNewCDDDPage}
            />
          </div>
          <GridWrapper>
            <SelectYourDiaperCTA
              particularRef={particularElementRef}
              text="SELECT YOUR FAVOURITE DIAPERS"
              setShowAnimation={setShowAnimation}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              productCount={productCount}
              isForNewCdPage={isForNewCdPage}
              lockedProductSectionRef={lockedProductSectionRef}
              nonFreebieProductCount={nonFreebieProductCount}
            />
          </GridWrapper>
          <GridWrapper>
            <HappinessPattern />
          </GridWrapper>

          {!isForNewCdPage && (
            <GridWrapper>
              <UniversalAccordion
                categoryAccordionData={categoryAccordionData}
              />
            </GridWrapper>
          )}

          <GridWrapper>
            <ScrollWrapper
              clothDiaper={true}
              sectionId="faqs"
              data={faqEventData}
            >
              <AccordionHeading>FAQs</AccordionHeading>
              <UniversalAccordion
                categoryAccordionData={FAQDataClothDiaper}
                faq={true}
              />
              <WhatsappStrip />
            </ScrollWrapper>
          </GridWrapper>

          {pageLiveCountValue && (
            <CDPageLiveCount
              pageLiveCountValue={pageLiveCountValue}
              changedIndexes={changedIndexes}
              description={liveCountText}
            />
          )}
          <GridWrapper>
            <SelectYourDiaperCTA
              particularRef={particularElementRef}
              selectDiaperRef={selectDiaperRef}
              text="SELECT YOUR FAVOURITE DIAPERS"
              setShowAnimation={setShowAnimation}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              productCount={productCount}
              isForNewCdPage={isForNewCdPage}
              lockedProductSectionRef={lockedProductSectionRef}
              nonFreebieProductCount={nonFreebieProductCount}
            />
          </GridWrapper>

          {isForNewCdPage && (
            <GridWrapper>
              <UniversalAccordion
                categoryAccordionData={categoryAccordionData}
              />
            </GridWrapper>
          )}

          <GridWrapper>
            {reviewdata?.data && (
              <LazyLoad height={500} once offset={400}>
                <RatingandReviews
                  reviewData={reviewdata?.data}
                  productData={{
                    id: 504,
                    name: 'reusable cloth diaper',
                    ...productData,
                  }}
                  clothDiaper={true}
                  showNewReviewView={showNewCDDDPage}
                />
              </LazyLoad>
            )}
          </GridWrapper>

          <GridWrapper>
            <ReadyToChoiceSection
              particularRef={particularElementRef}
              goTopRef={goTopRef}
              rtcImages={readyToChoiceGif}
              setShowAnimation={setShowAnimation}
              setShowHeader={setShowHeader}
              setShowTop={setShowTop}
              setShowLockedProductsAnimation={setShowLockedProductsAnimation}
              productCount={productCount}
              isForNewCdPage={isForNewCdPage}
              lockedProductSectionRef={lockedProductSectionRef}
              nonFreebieProductCount={nonFreebieProductCount}
            />
          </GridWrapper>
          <GotoTopButton showGoTop={showGoTop} scrollUp={handleScrollUp} />
          <NewFooter
            screen={'pdp'}
            heading={heading}
            content={htmlText}
            goTopRef={goTopRef}
            priceTable={priceTable}
            ratingTable={ratingTable}
            updatedOn={updatedOn}
          />
        </HiddenWrapper>
        {floatingVideoData?.items?.length && isVideoVisible && (
          <FloatingVideo
            currentVideoIndex={currentVideoIndex}
            multipleVideos={floatingVideoData?.items}
            hasStickyStrip={!hideStickyStrip}
            setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
            isCartOpen={isCartOpen}
            showFullScreenVideo={showFullScreenVideo}
            setShowFullScreenVideo={setShowFullScreenVideo}
            setCurrentVideoIndex={setCurrentVideoIndex}
          />
        )}
        {isForNewCdPage && (
          <SnackBar className={showB2G1Snackbar ? 'show' : ''}>
            {showB2G1Snackbar}
          </SnackBar>
        )}
      </DiaperWrapper>
    </>
  );
}
